const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function fetchAuthenticatedContent({
	endpoint,
	method = "GET",
	body = null,
	headers = null,
	extraParams = {},
	query = {},
	dispatch = null,
}) {
	const auth = new DrupalOAuth();
	let queryString = "";
	if (query && Object.keys(query).length > 0) {
		queryString += endpoint.includes("?") ? "&" : "?";
		queryString += new URLSearchParams(query).toString();
	}
	const content = await auth.drupalFetch(
		endpoint,
		method,
		body,
		headers,
		extraParams,
		dispatch
	);
	return content;
};
